




























































import Vue from "vue";
import statusQuery from "@/common/mixins/statusQuery";
import pagination from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import FilterErrorTracking from "../components/FilterErrorTracking.vue";
import { ErrorTrackingApplyPromotion } from "../models/ErrorTrackingApplyPromotion";
import {
  ErrorTrackingApplyPromotionForm,
  ErrorTrackingStatus
} from "../forms/ErrorTrackingApplyPromotionForm";
export default Vue.extend({
  mixins: [pagination, statusQuery, dialog],
  components: {
    FilterErrorTracking
  },
  data() {
    const isLoading = false;
    const fixed = ErrorTrackingStatus.FIXED;
    const errorTrackingsApplyPromotion: ErrorTrackingApplyPromotion[] = [];
    const errorTrackingApplyPromotionForm: ErrorTrackingApplyPromotionForm = {
      page: (this as any).currentPage,
      perPage: (this as any).perPage,
      status: undefined,
      search: ""
    };
    return {
      fixed,
      isLoading,
      errorTrackingsApplyPromotion,
      errorTrackingApplyPromotionForm
    };
  },
  async created() {
    this.isLoading = true;
    (this as any).getPaginationRouteQuery();
    (this as any).getStatusRouteQuery();
    this.isLoading = false;
  },
  computed: {
    presenterErrorTrackingsApplyPromotion() {
      return (this as any).errorTrackingsApplyPromotion.map(
        (applyPromotion: ErrorTrackingApplyPromotion) => {
          return {
            ...applyPromotion,
            isFixed: applyPromotion.status == ErrorTrackingStatus.FIXED
          };
        }
      );
    }
  },
  watch: {
    async "$route.query"() {
      this.setReportFilterForm();
    }
  },
  methods: {
    setReportFilterForm() {
      this.errorTrackingApplyPromotionForm = {
        ...this.errorTrackingApplyPromotionForm,
        page: (this as any).currentPage,
        search: (this as any).search,
        status: (this as any).status ? (this as any).status : undefined
      };
    },
    async getErrorTrackingApplyPromotion() {
      try {
        const {
          data,
          meta
        } = await (this as any).$dep.errorTrackingUseCase.getErrorTrackingApplyPromotion(
          this.errorTrackingApplyPromotionForm
        );
        this.errorTrackingsApplyPromotion = data;

        (this as any).setPaginationMeta(meta);
        (this as any).setSearchQuery(
          this.errorTrackingApplyPromotionForm.search
        );
        (this as any).setStatusQuery(
          this.errorTrackingApplyPromotionForm.status
        );
      } catch (error) {
        console.log(error);
      }
    },
    async changeStatusOption(option: string) {
      this.isLoading = true;
      if (option == "") {
        this.errorTrackingApplyPromotionForm = {
          ...this.errorTrackingApplyPromotionForm,
          status: undefined
        };
      } else if (option == ErrorTrackingStatus.WAIT) {
        this.errorTrackingApplyPromotionForm = {
          ...this.errorTrackingApplyPromotionForm,
          status: ErrorTrackingStatus.WAIT
        };
      } else if (option == ErrorTrackingStatus.FIXING) {
        this.errorTrackingApplyPromotionForm = {
          ...this.errorTrackingApplyPromotionForm,
          status: ErrorTrackingStatus.FIXING
        };
      } else if (option == ErrorTrackingStatus.FIXED) {
        this.errorTrackingApplyPromotionForm = {
          ...this.errorTrackingApplyPromotionForm,
          status: ErrorTrackingStatus.FIXED
        };
      }

      await this.getErrorTrackingApplyPromotion();
      this.isLoading = false;
    },
    async searchByButton() {
      await this.getErrorTrackingApplyPromotion();
    },
    async resolveDialog(id: number) {
      const isComfirmed = await (this as any).alertConfirm(
        "Resolve",
        `คุณต้องการที่จะ Resolve Id : ${id} ใช่ไหม?`
      );
      if (isComfirmed) {
        this.resolve(id);
      }
    },
    async resolve(id: number) {
      try {
        await (this as any).$dep.errorTrackingUseCase.resolveApplyPromotionErrorTracking(
          id
        );
        (this as any).alertSuccess("Success", "Resolve สำเร็จ");
        this.getErrorTrackingApplyPromotion();
      } catch (error) {
        console.log(error);
      }
    }
  }
});
